import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";

import InputDate from "../../atoms/InputDate/InputDate";
import { QuestionProps } from "../../../types/components/molecules/questionProps";

const Nineth = ({ formData, setFormData, onValidationChange }: QuestionProps) => {
  const { t } = useTranslation();

  useEffect(() => {
    onValidationChange?.(!!formData.last_vet_visit_date);
  }, [formData.last_vet_visit_date, onValidationChange]);

  return (
    <InputDate
      label={t("animalInfo:QUESTION_NINE.LAST_VISIT")}
      value={formData.last_vet_visit_date ? dayjs(formData.last_vet_visit_date) : null}
      onChange={(value) =>
        setFormData({
          ...formData,
          last_vet_visit_date: value?.toISOString(),
        })
      }
      minDate={formData.birth_date ? dayjs(formData.birth_date) : undefined}
    />
  );
};

export default Nineth;
